import {PRIVATE, MEDICARE} from '../../enums/InsuranceType'
import _ from 'lodash/fp'
import {required} from '../../utils/validation'
import {OTHER } from '../../enums/ContactRelationType'
export const getCoveredAndCharge = (payment) => {
  const chargeValue = payment?.chargeValue || 0
  return [0,chargeValue]
}

const INSURANCE_PREFIX = 'patientInfo.insurances'
export const INSURANCE_REQUIRED_KEYS = ['insuranceCarrier', 'memberNumber', 'groupNumber']
export const ALL_INSURANCE_REQUIRED_KEYS = INSURANCE_REQUIRED_KEYS.concat("insurancedName")
export const MEDICARE_REQUIRED_KEYS = ['code']
export const OTHER_REQUIRED_KEYS = ['info']
const KEYS_FOR_TYPE = {
  [MEDICARE]:MEDICARE_REQUIRED_KEYS,
  [OTHER]: OTHER_REQUIRED_KEYS,
  [PRIVATE]: INSURANCE_REQUIRED_KEYS
}
const KEYS_FOR_TYPE_ALL = {
  ...KEYS_FOR_TYPE,
  [PRIVATE]: ALL_INSURANCE_REQUIRED_KEYS
}
export const checkInsurance = ({id,type,...rest}, i, forceValidation) => (forceValidation || Object.values(rest).find(_.identity))
    ? generalCheckInsurance(rest,type,i)
    : []
const generalCheckInsurance = (insurance, type, i) => {
  return KEYS_FOR_TYPE[type]
    .map(k => [INSURANCE_PREFIX + '[' + i + '].' + k, required(insurance[k])]).filter(([, v]) => v)
}

export const removeExtraInsuranceFields = ({id,type,...rest}) =>
  ({id,type,..._.pick(KEYS_FOR_TYPE_ALL[type],rest)})

// form.path for each default step
// export const STEP_PATIENT_INFO = "patientInfo"
// export const STEP_CONTACT_INFO = "contactDetails"
// export const STEP_CASE_INFO = "caseInfo"
// export const STEP_CASE_SETTINGS = "caseSettings"
// export const STEP_PHYSICIANS = "physicians"
// export const STEP_INSURANCE = "insurances" 
// export const STEP_CASE_RECONCILIATION = "caseReconciliation"

export const TAB_TYPE_CUSTOM = "CUSTOM"
export const TAB_CUSTOM_ID_PREFIX = "tab-"

export const STEP_PATIENT_INFO = "PATIENT_IDENTIFICATION"
export const STEP_CONTACT_INFO = "CONTACT_PARTY"
export const STEP_CASE_INFO = "PRIMARY_CONCERN"
export const STEP_PHYSICIANS = "PHYSICIAN"
export const STEP_INSURANCE = "INSURANCE_INFORMATION"
export const STEP_CASE_RECONCILIATION = "caseReconciliation"
export const STEP_CASE_SETTINGS = "caseSettings"

export const getPathForTab = (tabId) => {
  switch (tabId) {
    case STEP_PATIENT_INFO:
      return "patientInfo"
    case STEP_CONTACT_INFO:
      return "contactDetails"
    case STEP_CASE_INFO:
      return "caseInfo"
    case STEP_CASE_SETTINGS:
      return "categories"
    case STEP_PHYSICIANS:
      return "physicians"
    case STEP_INSURANCE:
      return "insurances"
    case STEP_CASE_RECONCILIATION:
      return "caseReconciliation"
    default:
      return `${tabId}` //tabId
  }
}

export const buildIntakeFormsSteps = ({language, isAdmin, caseReconciliationEnabled, isNurse = false}) => {
  const isLegal = language.indexOf("LEGAL") >= 0
  
  let steps = isLegal ? [{
      order: 0,
      number: 0,
      id: STEP_PATIENT_INFO,
      label: "Client identification",
      pageTitle: "Client identification",
      pageSubTitle: "Enter client information",
      formPath: "patientInfo"
    },
    {
      order: 1,
      number: 1,
      id: STEP_CONTACT_INFO,
      label: "Contact information",
      pageTitle: "Contact information",
      pageSubTitle: "Primary contact information for the client or client representative.",
      formPath: "contactDetails"
    },
    {
      order: 4,
      number: 4,
      id: STEP_CASE_INFO,
      label: "Case Details",
      pageTitle: "Case Details",
      formPath: "caseInfo"
    },
    {
      order: 99,
      number: 99,
      id: STEP_CASE_SETTINGS,
      label: "Case settings",
      pageTitle: "Case settings",
      pageSubTitle: "Manage the divisions that can access this case",
      formPath: "categories"
    }
  ] : [
    {
      order: 0,
      number: 0,
      id: STEP_PATIENT_INFO,
      label: "Patient identification",
      pageTitle: "Patient identification",
      pageSubTitle: "Enter patient information",
      formPath: "patientInfo"
    },
    {
      order: 1,
      number: 1,
      id: STEP_CONTACT_INFO,
      label: "Contact party",
      pageTitle: "Contact party",
      pageSubTitle: "This is the party responsible for this case. They may be contacted about patient information, medical records, payment, and the case report as applicable.",
      formPath: "contactDetails"
    },
    {
      order: 2,
      number: 2,
      id: STEP_PHYSICIANS,
      label: "Physician",
      pageTitle: "Physician (Local and/or Referring)",
      pageSubTitle: "Can be requested to take action on this case and may receive a copy of any resulting results.",
      formPath: "referringPhysicians"
    },
    {
      order: 3,
      number: 3,
      id: STEP_INSURANCE,
      label: "Insurance information",
      pageTitle: "Insurance information",
      pageSubTitle: "In most cases, this service will not be covered by insurance. Only complete this section if you have been advised to by your care coordinator. This information will only be used should there be any covered procedure.",
      formPath: "patientInfo.insurances"
    },
    {
      order: 4,
      number: 4,
      id: STEP_CASE_INFO,
      label: "Primary concern",
      pageTitle: "Primary concern",
      formPath: "caseInfo"
    },
    {
      number: 98,
      order: 98,
      id: STEP_CASE_RECONCILIATION,
      label: "Case reconciliation",
      pageTitle: "Case reconciliation",
      pageSubTitle: "Insert the information below to export this case to your EHR system",  
    },
    {
      order: 99,
      number: 99,
      label: "Case settings",
      id: STEP_CASE_SETTINGS,
      pageTitle: "Case settings",
      pageSubTitle: "Manage the divisions that can access this case",
      formPath: "categories"
    },
  ]
  
  if(!caseReconciliationEnabled || !isAdmin) {
    steps = steps.filter(step => step.number !== 98)
  }

  if(!isAdmin && !isNurse) {
    steps = steps.filter(step => step.id !== STEP_CASE_SETTINGS)
  }

  return steps
}